import {
  FETCH_FRIENDS_INFO,
  ADD_FRIEND,
  ADD_FRIEND_FETCH,
  DELETE_ADD_FRIEND,
  DELETE_ADD_FRIEND_FETCH,
  REFUSE_ADD_FRIEND,
  REFUSE_ADD_FRIEND_FETCH,
  ACCEPT_ADD_FRIEND,
  DELETE_FRIEND,
  ACCEPT_ADD_FRIEND_FETCH,
  DELETE_FRIEND_FETCH
} from "./types";

import firebase from "firebase";
import { fetchFromFirebase } from "../helpers/fetchFriends";
import { Dispatch } from "react";
import { auth, database } from "../../App";
import { friendActionInterface } from "../reducers/FriendsReducers";

export const fetchFriendsInfo = () => {
  const { currentUser } = auth;

  return (dispatch: Dispatch<friendActionInterface>) => {
    dispatch({ type: FETCH_FRIENDS_INFO });
    fetchFromFirebase(currentUser, dispatch);
  };
};

export const addFriend = (
  otherUserId: string,
  otherUserUserName: string,
  currentUserName: string
) => (dispatch: Dispatch<friendActionInterface>) => {
  dispatch({
    type: ADD_FRIEND
  });
  const { currentUser } = auth;
  currentUser &&
    friendsHelperUpdateAndUpdateCount(
      "friend_requests_sent",
      otherUserUserName,
      otherUserId,
      currentUser.uid,
      dispatch,
      { type: ADD_FRIEND_FETCH }
    ) &&
    friendsHelperUpdateAndUpdateCount(
      "friend_requests_received",
      currentUserName,
      currentUser.uid,
      otherUserId
    );
};

export const deleteFriend = (
  otherId: string,
  otherUserUserName: string,
  currentUserName: string
) => {
  return (dispatch: Dispatch<friendActionInterface>) => {
    dispatch({ type: DELETE_FRIEND });
    const { currentUser } = auth;
    currentUser &&
      helperDeleteAndUpdateCount(
        otherUserUserName,
        currentUser.uid,
        "friends"
      ) &&
      helperDeleteAndUpdateCount(
        currentUserName,
        otherId,
        "friends",
        dispatch,
        { type: DELETE_FRIEND_FETCH }
      );
  };
};

export const deleteAddFriendRequest = (
  id: string,
  username: string,
  currentUserName: string
) => {
  return (dispatch: Dispatch<friendActionInterface>) => {
    dispatch({ type: DELETE_ADD_FRIEND });
    const { currentUser } = auth;
    otherUserDeleteReceiveRequest(id, currentUserName);
    currentUserDeleteSendRequest(currentUser, username, dispatch);
  };
};

export const refuseAddFriendRequest = (
  id: string,
  username: string,
  currentUserName: string
) => {
  return (dispatch: Dispatch<friendActionInterface>) => {
    dispatch({ type: REFUSE_ADD_FRIEND });
    const { currentUser } = auth;
    deleteReceivedAndSentRequest(
      currentUser,
      id,
      username,
      dispatch,
      currentUserName
    );
  };
};

export const acceptAddFriendRequest = (
  otherId: string,
  otherUsername: string,
  currentUserName: string
) => {
  return (dispatch: Dispatch<friendActionInterface>) => {
    dispatch({ type: ACCEPT_ADD_FRIEND });
    const { currentUser } = auth;
    if (!currentUser) {
      return;
    }
    deleteReceivedAndSentRequest(
      currentUser,
      otherId,
      otherUsername,
      dispatch,
      currentUserName
    );
    friendsHelperUpdateAndUpdateCount(
      "friends",
      otherUsername,
      otherId,
      currentUser.uid,
      dispatch,
      { type: ACCEPT_ADD_FRIEND_FETCH }
    );
    friendsHelperUpdateAndUpdateCount(
      "friends",
      currentUserName,
      currentUser.uid,
      otherId
    );
  };
};

function deleteReceivedAndSentRequest(
  currentUser: firebase.User | null,
  id: string,
  username: string,
  dispatch: Dispatch<friendActionInterface>,
  currentUserName: string
) {
  otherUserRefuseSentRequest(id, currentUserName);
  currentUserRefuseReceivedRequest(currentUser, username, dispatch);
}

function currentUserDeleteSendRequest(
  currentUser: firebase.User | null,
  otherUserUserName: string,
  dispatch: Dispatch<friendActionInterface>
) {
  if (!currentUser) {
    return;
  }
  const friend_requests_sent = database
    .ref("users")
    .child(currentUser.uid)
    .child("friends_info")
    .child("friend_requests_sent");

  friend_requests_sent
    .child("data")
    .child(otherUserUserName)
    .remove()
    .then(() => {
      friend_requests_sent
        .child("count")
        .transaction(value => (value || 1) - 1);
      dispatch({ type: DELETE_ADD_FRIEND_FETCH });
    });
}

function otherUserDeleteReceiveRequest(
  otherUserId: string,
  currentUserName: string
) {
  const friend_requests_received = database
    .ref("users")
    .child(otherUserId)
    .child("friends_info")
    .child("friend_requests_received");

  friend_requests_received
    .child("data")
    .child(currentUserName)
    .remove()
    .then(() => {
      friend_requests_received
        .child("count")
        .transaction(value => (value || 1) - 1);
    });
}

function currentUserRefuseReceivedRequest(
  currentUser: firebase.User | null,
  otherUserUserName: string,
  dispatch: Dispatch<friendActionInterface>
) {
  if (!currentUser) {
    return;
  }
  const friend_requests_received = database
    .ref("users")
    .child(currentUser.uid)
    .child("friends_info")
    .child("friend_requests_received");
  friend_requests_received
    .child("data")
    .child(otherUserUserName)
    .remove()
    .then(() => {
      friend_requests_received
        .child("count")
        .transaction(value => (value || 1) - 1);
      dispatch({ type: REFUSE_ADD_FRIEND_FETCH });
    });
}

function otherUserRefuseSentRequest(
  otherUserId: string,
  currentUserName: string
) {
  const friend_requests_sent = database
    .ref("users")
    .child(otherUserId)
    .child("friends_info")
    .child("friend_requests_sent");
  friend_requests_sent
    .child("data")
    .child(currentUserName)
    .remove()
    .then(() => {
      friend_requests_sent
        .child("count")
        .transaction(value => (value || 1) - 1);
    });
}

function friendsHelperUpdateAndUpdateCount(
  childName: string,
  otherUsername: string,
  otherUid: string,
  currentUid: string,
  dispatch?: Dispatch<any>,
  dispatchValue?: any
) {
  const friendInfoSelected = database
    .ref(`users`)
    .child(currentUid)
    .child("friends_info")
    .child(childName);
  return friendInfoSelected
    .child("data")
    .update({
      [otherUsername]: otherUid
    })
    .then(() => {
      friendInfoSelected.child("count").transaction(value => (value || 0) + 1);
      dispatch && dispatchValue && dispatch(dispatchValue);
    });
}

function helperDeleteAndUpdateCount(
  otherUserUserName: string,
  currentUid: string,
  childName: string,
  dispatch?: Dispatch<any>,
  dispatchValue?: any
) {
  const friendInfoSelected = database
    .ref("users")
    .child(currentUid)
    .child("friends_info")
    .child(childName);
  return friendInfoSelected
    .child("data")
    .child(otherUserUserName)
    .remove()
    .then(() => {
      friendInfoSelected.child("count").transaction(value => (value || 1) - 1);
      dispatch && dispatchValue && dispatch(dispatchValue);
    });
}
